<template>
    <div id="vehicle_pool_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <!-- <span class="page-title" id="vehiclePoolHeader" v-if="$route.params.id > 0">Update Asset Pool</span>
                    <span class="page-title" id="vehiclePoolHeader" v-else>Add Asset Pool</span> -->
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehiclePoolList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-pool-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VehiclePoolForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                        <div class="field-error">{{description_error_msg}}</div>
                                    </div> 
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <div class="custom-checkbox">
                                            <label for="assetpool" class="checkbox-custom"> Asset Pool Default
                                            <input type="checkbox" v-model="assetpool" id="assetpool" name="assetpool" v-on:click="checkSelected"> 
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVehiclePoolBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateVehiclePool" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createVehiclePoolBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateVehiclePool" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueVehiclePoolBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateVehiclePool(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelVehiclePoolBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehiclePoolList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

 



export default {
  name: "VehiclePoolCreate",
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Asset Pool | " +process.env.COPYRIGHT_NAME : "Create Asset Pool | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    code: "",
    description: "",
    checkboxValue: "",
    checked: "",
    loading:false,
    code_error_msg: "",
    description_error_msg: ""
  }),
    watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_pool') {
                        self.cantAccessPage = true;

                    }
                }
            }

        }
    },
  created: function() {

  },
  mounted: function() {

        var self = this;
        self.checkboxValue = 0;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {
            self.loadVehiclePool();
        }
  },
  methods: {

    BackVehiclePoolList() {
      var self = this;
      self.$router.push("/assetpool/list");
    },

    checkSelected() {
        var self = this;
        if (self.checked != true) {
            self.checkboxValue = 1;
        } else {
            self.checkboxValue = 0;
        }
    },

    CreateVehiclePool(flag) {
      var self = this;

      self.code = self.code.trim();

      self.code_error_msg = "";
      self.description_error_msg = "";

      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Code Required.";
      }

      if (!self.description || self.description == null || self.description == "") {
        self.description_error_msg = "Description Required.";
      }

      if (self.code_error_msg == "" && self.description_error_msg == "") {
        self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehiclePoolBtn").val("Updating ...");
                $("#createVehiclePoolBtn").prop("disabled", true);
                $("#cancelVehiclePoolBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehiclePoolBtn").val("Saving ...");
                    $("#createVehiclePoolBtn").prop("disabled", true);
                    $("#createAndContinueVehiclePoolBtn").prop("disabled", true);
                    $("#cancelVehiclePoolBtn").prop("disabled",true);

                }else{

                    $("#createVehiclePoolBtn").val("Saving ...");
                    $("#createVehiclePoolBtn").prop("disabled", true);
                    $("#createAndContinueVehiclePoolBtn").prop("disabled", true);
                    $("#cancelVehiclePoolBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/assetpool/create",
                type: "POST",
                data: {code: self.code, description: self.description, is_vehicle_pool: self.checkboxValue, id: segments[3]},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehiclePoolBtn").val("Update");
                        $("#createVehiclePoolBtn").prop("disabled", false);
                        $("#cancelVehiclePoolBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehiclePoolBtn").val("Save and Continue");
                            $("#createVehiclePoolBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePoolBtn").prop("disabled", false);
                            $("#cancelVehiclePoolBtn").prop("disabled",false);

                        }else{

                            $("#createVehiclePoolBtn").val("Save");
                            $("#createVehiclePoolBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePoolBtn").prop("disabled", false);
                            $("#cancelVehiclePoolBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#VehiclePoolForm").trigger("reset");
                            self.code ="";
                            self.description ="";
                            self.checkboxValue = "";
                            self.checked = "";  

                        }else{
                            self.$router.push("/assetpool/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehiclePoolBtn").val("Update");
                        $("#createVehiclePoolBtn").prop("disabled", false);
                        $("#cancelVehiclePoolBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#VehiclePoolForm").trigger("reset");
                            

                            $("#createAndContinueVehiclePoolBtn").val("Save and Continue");
                            $("#createVehiclePoolBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePoolBtn").prop("disabled", false);
                            $("#cancelVehiclePoolBtn").prop("disabled",false);

                        }else{

                            $("#createVehiclePoolBtn").val("Save");
                            $("#createVehiclePoolBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePoolBtn").prop("disabled", false);
                            $("#cancelVehiclePoolBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'asset-pool-create')
                }
            });
      }else{
                self.errorValidationFocus();
        }

     
    },

    loadVehiclePool() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/assetpool/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.code = data.content.code;
                    self.description = data.content.description;
                    self.checked = data.content.is_vehicle_pool;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'asset-pool-by-id')
            }
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AssetPoolCreate.vue